/**
 * Fecha de calendario (DATE) sin desfase UTC.
 *
 * Regla: si el valor trae YYYY-MM-DD al inicio, esa es la fecha de negocio.
 * Evita el -1/+1 día de new Date('YYYY-MM-DD').toLocaleDateString() en UY.
 */
export function toDateOnlyYYYYMMDD(raw) {
  if (raw == null || raw === '') return '';

  if (typeof raw === 'string') {
    const trimmed = raw.trim().replace(' ', 'T');
    const prefix = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (prefix) {
      return `${prefix[1]}-${prefix[2]}-${prefix[3]}`;
    }
    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) {
      const y = parsed.getFullYear();
      const m = String(parsed.getMonth() + 1).padStart(2, '0');
      const d = String(parsed.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
    return '';
  }

  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    // Preferir componentes UTC si es medianoche UTC (DATE típico de MySQL/JSON)
    if (
      raw.getUTCHours() === 0 &&
      raw.getUTCMinutes() === 0 &&
      raw.getUTCSeconds() === 0
    ) {
      const y = raw.getUTCFullYear();
      const m = String(raw.getUTCMonth() + 1).padStart(2, '0');
      const d = String(raw.getUTCDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
    const y = raw.getFullYear();
    const m = String(raw.getMonth() + 1).padStart(2, '0');
    const d = String(raw.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  return '';
}

/** Fecha a mostrar de un servicio: agenda si existe, si no vehicle_services.date */
export function getServiceCalendarDate(service) {
  if (!service) return '';
  const agendaList = Array.isArray(service.agenda)
    ? service.agenda
    : service.agenda
      ? [service.agenda]
      : [];
  const agendaDate = agendaList.find((a) => a?.date)?.date;
  return toDateOnlyYYYYMMDD(agendaDate || service.date || '');
}

export function formatDateOnlyDisplay(raw) {
  const ymd = toDateOnlyYYYYMMDD(raw);
  if (!ymd) return '—';
  const [year, month, day] = ymd.split('-');
  return `${day}/${month}/${year}`;
}

const MONTHS_ES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/** Ej: "17 de julio de 2026" sin desfase UTC. */
export function formatDateOnlyLong(raw, fallback = 'Fecha no disponible') {
  const ymd = toDateOnlyYYYYMMDD(raw);
  if (!ymd) return fallback;
  const [year, month, day] = ymd.split('-').map(Number);
  const monthName = MONTHS_ES[month - 1];
  if (!monthName) return fallback;
  return `${day} de ${monthName} de ${year}`;
}

export function formatServiceDateLong(service, fallback = 'Sin fecha') {
  const ymd = getServiceCalendarDate(service);
  return ymd ? formatDateOnlyLong(ymd, fallback) : fallback;
}

export function formatServiceDateDisplay(service) {
  const ymd = getServiceCalendarDate(service);
  return ymd ? formatDateOnlyDisplay(ymd) : '—';
}
